<template>
  <div class="confetti_container">
    <img v-for="index in 10" :key="index" src="@/assets/seedling.png" class="ourforest-confetti"/>
  </div>
</template>

<script></script>

<style>
.confetti_container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.ourforest-confetti {
  width: 32px;
  height: 32px;
  position: absolute;
  left: 50%;
  animation: confetti 8s ease-in-out -2s 1;
  transform-origin: left top;
}
.ourforest-confetti:nth-child(1) {
  left: 10%;
  animation-delay: 0;
}
.ourforest-confetti:nth-child(2) {
  left: 20%;
  animation-delay: -5s;
}
.ourforest-confetti:nth-child(3) {
  left: 30%;
  animation-delay: -3s;
}
.ourforest-confetti:nth-child(4) {
  left: 40%;
  animation-delay: -2.5s;
}
.ourforest-confetti:nth-child(5) {
  left: 50%;
  animation-delay: -4s;
}
.ourforest-confetti:nth-child(6) {
  left: 60%;
  animation-delay: -6s;
}
.ourforest-confetti:nth-child(7) {
  left: 70%;
  animation-delay: -1.5s;
}
.ourforest-confetti:nth-child(8) {
  left: 80%;
  animation-delay: -2s;
}
.ourforest-confetti:nth-child(9) {
  left: 90%;
  animation-delay: -3.5s;
}
.ourforest-confetti:nth-child(10) {
  left: 100%;
  animation-delay: -2.5s;
}

@keyframes confetti {
  0% {
    transform: rotateZ(15deg) rotateY(0deg) translate(0, 0);
  }
  25% {
    transform: rotateZ(5deg) rotateY(360deg) translate(-5vw, 20vh);
  }
  50% {
    transform: rotateZ(15deg) rotateY(720deg) translate(5vw, 60vh);
  }
  75% {
    transform: rotateZ(5deg) rotateY(1080deg) translate(-10vw, 80vh);
  }
  100% {
    transform: rotateZ(15deg) rotateY(1440deg) translate(10vw, 110vh);
  }
}
</style>
